// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { getBrowserName } from "../utils/Common/Constant";
import { CommonEnums } from "../utils/Enums/CommonEnums";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FCM_APIKEY,
  authDomain: process.env.REACT_APP_FCM_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FCM_PROJECTID,
  storageBucket: process.env.REACT_APP_FCM_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FCM_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FCM_APPID,
  measurementId: process.env.REACT_APP_FCM_MEASUREMENTID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging: any =
  getBrowserName() !== CommonEnums.BROWSER_SAFARI ? getMessaging(app) : null;
export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });
    return token;
  }
};
